import type { ToasterProps } from 'sonner'

/** Mirrors the backend ToasterPosition enum */
export const ToasterPosition = {
  TOP_LEFT: 'TOP_LEFT',
  TOP_CENTER: 'TOP_CENTER',
  TOP_RIGHT: 'TOP_RIGHT',
  BOTTOM_LEFT: 'BOTTOM_LEFT',
  BOTTOM_CENTER: 'BOTTOM_CENTER',
  BOTTOM_RIGHT: 'BOTTOM_RIGHT',
} as const

export type ToasterPosition = keyof typeof ToasterPosition

export interface IToasterSetting {
  position: ToasterPosition
  closeButton: boolean
  expand: boolean
  duration: number
  visibleToasts: number
  /** True when the organisation has not saved a setting and the defaults are returned */
  isDefault?: boolean
}

/** Used until the organisation setting loads, and whenever the organisation has not set one */
export const DEFAULT_TOASTER_SETTING: IToasterSetting = {
  position: ToasterPosition.TOP_RIGHT,
  closeButton: true,
  expand: false,
  duration: 5000,
  visibleToasts: 3,
}

export const TOASTER_POSITION_TO_SONNER: Record<ToasterPosition, NonNullable<ToasterProps['position']>> = {
  TOP_LEFT: 'top-left',
  TOP_CENTER: 'top-center',
  TOP_RIGHT: 'top-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_CENTER: 'bottom-center',
  BOTTOM_RIGHT: 'bottom-right',
}

export const TOASTER_POSITION_OPTIONS: { value: ToasterPosition; label: string }[] = [
  { value: ToasterPosition.TOP_LEFT, label: 'Top Left' },
  { value: ToasterPosition.TOP_CENTER, label: 'Top Centre' },
  { value: ToasterPosition.TOP_RIGHT, label: 'Top Right' },
  { value: ToasterPosition.BOTTOM_LEFT, label: 'Bottom Left' },
  { value: ToasterPosition.BOTTOM_CENTER, label: 'Bottom Centre' },
  { value: ToasterPosition.BOTTOM_RIGHT, label: 'Bottom Right' },
]

/** Durations in milliseconds; must stay within the backend's 1000-30000 bounds */
export const TOASTER_DURATION_OPTIONS: { value: number; label: string }[] = [
  2000, 3000, 4000, 5000, 8000, 10000, 15000, 30000,
].map((value) => ({ value, label: `${value / 1000} seconds` }))

/** Must stay within the backend's 1-10 bounds */
export const TOASTER_VISIBLE_TOASTS_OPTIONS: { value: number; label: string }[] = Array.from(
  { length: 10 },
  (_, index) => ({ value: index + 1, label: `${index + 1}` })
)
